/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import H3 from '@base/H3/H3';
import Drawer from '@base/Drawer/Drawer';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import StoryItem from '@comp/StoryItem/StoryItem';
import Dropdown from '@comp/Dropdown/Dropdown';
import { useDispatchToStore } from '@hooks/reduxHooks';
import {
  fetchCourseUpdates,
  fetchUpdateFilters,
  updateFilters
} from '@actions/courses';

import DiscussionForum from '@educator/Container/CourseDetails/DiscussionForum';

const Header = styled(H3)`
  grid-column: span 10;
  color: var(--color-text-primary);
  margin-bottom: 24px;
`;

const Loader = styled(CircularLoader)`
  grid-column: 5/6;
`;

const Updates = ({ showUpdates, segmentData, onCloseUpdates, channelId }) => {
  const router = useRouter();
  const dispatch = useDispatchToStore();
  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);

  const { filter_type, filter_value } = router.query;
  let queryFilter;
  if (filter_type && filter_value) {
    queryFilter = {
      label: filter_type,
      value: Number(filter_value)
    };
  }

  const onFilterClick = (filter) => {
    dispatch(updateFilters(filter, filter ? 'other' : '', !filter));
    const requiredFilter = filter && [
      { filter_type: filter.label, filter_value: filter.value }
    ];
    dispatch(fetchCourseUpdates(channelId, true, true, false, requiredFilter));
  };

  useEffect(() => {
    onFilterClick(queryFilter);
    dispatch(fetchUpdateFilters(channelId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, channelId]);

  useEffect(() => {
    setTimeout(() => {
      setIsInitialLoadDone(showUpdates);
    }, 10);
  }, [showUpdates]);

  const channelStories = useSelector(
    (state) => state.paginator.courseUpdates[channelId]
  );

  const filters = useSelector((state) => state.updates.filters);

  const selectedFilter = useSelector((state) => state.updates.selectedFilter);

  const loadMoreStories = () => dispatch(fetchCourseUpdates(channelId, true));

  const handleOnPressBack = () => setSelectedStory(null);

  const renderUpdate = (story) => {
    if (!story) return null;
    return (
      <StoryItem
        story={story}
        selectedStory={selectedStory}
        channelId={channelId}
        setSelectedStory={setSelectedStory}
        segmentData={segmentData}
        onCloseUpdates={onCloseUpdates}
      />
    );
  };

  const storiesCount = channelStories?.results?.length;
  const isFetching = channelStories?.isFetching;

  const renderFilter = () => {
    if ((isFetching && storiesCount < 1) || selectedStory || storiesCount < 1)
      return;
    return (
      <Dropdown
        options={filters}
        selectedOption={selectedFilter}
        onOptionClick={onFilterClick}
        gridColumn="span 5"
      />
    );
  };

  const getHeader = () => {
    if (isFetching && storiesCount < 1) return <Loader />;
    let text = 'No updates available';
    if (storiesCount) text = 'Updates';
    return <Header>{text}</Header>;
  };

  return (
    <Drawer
      drawerState={showUpdates}
      onClose={onCloseUpdates}
      showBackButton={selectedStory}
      hideCloseButton={selectedStory}
      onPressBack={handleOnPressBack}
    >
      {getHeader()}
      {renderFilter()}
      {!selectedStory && <DiscussionForum channelId={channelId} />}
      {renderUpdate(selectedStory)}
      {isInitialLoadDone && storiesCount && !selectedStory ? (
        <InfiniteList
          data={channelStories}
          loadMore={loadMoreStories}
          _renderItem={renderUpdate}
          scrollElement={document.getElementById('DrawerPaper')}
        />
      ) : null}
    </Drawer>
  );
};

export default Updates;
